import {
  Drawer,
  PageHeader,
  Tag,
  Comment,
  Avatar,
  DatePicker,
  TimePicker,
  Button,
  Typography,
  Select,
} from "antd";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import axiosInstance from "../../config/axios-instance";
import avatar_placeholder from "../../img/avatar_placeholder.jpg";
import demcosvg from "../../img/logo_green.svg";
import { MyNotif } from "../NotifIcons/NotifIcons";
const { Text } = Typography;
const { Option } = Select;

function ConfirmDrawerClient({
  meet,
  clientConfirmDrawer,
  setClientConfirmDrawer,
  onCloseConfirmDrawerClient,
  refetch,
}: any) {
  const [rescheduleIt, setRescheduleIt] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const { user } = useSelector((state: any) => state.auth);
  const [data, setData] = useState<any>(null);
  const [collaborator, setCollaborators] = useState<any>(null);

  useEffect(() => {
    if (meet) {
      setData(meet.start);
      setIsConfirmed(meet.details.status === "accepted");
    }
  }, [meet, clientConfirmDrawer]);

  const genStatus = (status: any) => {
    switch (status) {
      case "new":
        return {
          text: "New",
          color: "blue",
        };
      case "waiting":
        return {
          text: "Pending",
          color: "orange",
        };
      case "accepted":
        return {
          text: "Confirmed",
          color: "green",
        };
      default:
        return {
          text: "Cancelled",
          color: "red",
        };
    }
  };

  const rescheduleMeeting = async (type: string) => {
    let token = localStorage.getItem("token");
    if (type === "cancel") {
      await axiosInstance({
        method: "delete",
        url: `/bookings/${meet.id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } else {
      await axiosInstance({
        method: "post",
        url: `/bookings/${meet.id}`,
        data: {
          status: type === "confirm" ? "accepted" : "waiting",
          date: data,
          client_id: user.id,
          _method: "patch",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    MyNotif(
      type === "cancel"
        ? "Meeting cancelled successfully."
        : type === "confirm"
        ? "Meeting confirmed successfully."
        : "Meeting rescheduled successfully.",
      "success"
    );
    setClientConfirmDrawer(false);
    refetch();
    // return response.data;
  };

  const {
    mutate: mutateUpdateBooking,
    isLoading: updateLoading,
    variables,
  } = useMutation((type: string) => rescheduleMeeting(type));

  const closeDrawer = useCallback(() => {
    onCloseConfirmDrawerClient();
    setIsConfirmed(false);
    setRescheduleIt(false);
  }, [meet]);

  return (
    <Drawer
      placement={"right"}
      closable={false}
      onClose={closeDrawer}
      visible={clientConfirmDrawer}
      key={"right"}
      width="400"
      className="booking-drawer"
    >
      {meet && (
        <div className="left-calendar-container">
          <h1 className="h1-blue-hj" style={{ marginTop: "20px" }}>
            Meeting details
          </h1>
          <PageHeader
            title={meet.subject}
            className="site-page-header p-0 my-5"
            tags={
              <Tag color={genStatus(meet.status).color}>
                {genStatus(meet.status).text}
              </Tag>
            }
            avatar={{
              src: demcosvg,
              className: "demco_drawer_confirmation_logo",
              alt: "Demco Logo",
            }}
          >
            <Comment
              className="meeting_notes border rounded pl-2 bg-white"
              author={meet.details.user && <a>{meet.details.user.name}</a>}
              avatar={
                <Avatar
                  shape="square"
                  src={
                    meet.details.user
                      ? process.env.REACT_APP_STORAGE_URL +
                        meet.details.user.avatar
                      : avatar_placeholder
                    // meet.commercial && meet.commercial.logo
                    //   ? process.env.REACT_APP_STORAGE_URL + meet.commercial.logo
                    //   : avatar_placeholder
                  }
                  alt={meet.details.user && meet.details.user.name}
                />
              }
              content={<p>{meet.notes}</p>}
            />
          </PageHeader>
          <h3 className="h2-blue-hj">Select Date</h3>
          <DatePicker
            disabled={isConfirmed || !rescheduleIt}
            defaultValue={moment(meet.start)}
            showToday={false}
            disabledDate={function disabledDate(current: any) {
              // Can not select days before today and today
              return (
                (current &&
                  current <= moment().subtract(1, "d").endOf("day")) ||
                ["Saturday", "Sunday"].find(
                  (date) => date === moment(current).format("dddd")
                )
              );
            }}
            onChange={(x: any) =>
              setData(
                moment(x)
                  .set({
                    hour: moment(data).get("hour"),
                    minute: moment(data).get("minute"),
                    second: moment(data).get("second"),
                  })
                  .format()
              )
            }
            style={{ width: "100%" }}
          />
          <h3 className="h2-blue-hj">Select Meeting Hour</h3>
          <TimePicker
            disabled={isConfirmed || !rescheduleIt}
            onChange={(x: any) =>
              setData(
                moment(data)
                  .set({
                    hour: x.get("hour"),
                    minute: x.get("minute"),
                    second: x.get("second"),
                  })
                  .format()
              )
            }
            style={{ width: "100%" }}
            defaultValue={moment(meet.start).utc()}
            showSecond={false}
            disabledHours={() => [
              0, 1, 2, 3, 4, 5, 6, 7, 17, 18, 19, 20, 21, 22, 23,
            ]}
            hideDisabledOptions
            minuteStep={15}
          />
          {meet.duration && (
            <>
              <h3 className="h2-blue-hj">Meeting Duration</h3>
              <div className="d-flex align-items-center border p-2 bg-white mb-4">
                <Text strong>{meet.duration} Hour(s)</Text>
              </div>
            </>
          )}
          {meet.details?.members && (
            <>
              <h3 className="h2-blue-hj">Select Collaborators</h3>
              <Select
                disabled
                mode="multiple"
                className="w-100"
                //    onChange={handleClient}
                /* loading={loadingClients} */
                /*  value={
                   selectedClient || (selectedEvent && selectedEvent.client.name)
                 } */
                placeholder="Select Collaborators"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                defaultValue={
                  meet.details?.members &&
                  meet.details?.members?.map((collaborator: any) => [
                    collaborator.name,
                  ])
                }
              >
                {meet.details?.members &&
                  meet.details?.members?.map((collaborator: any) => (
                    <Option value={collaborator?.id}>
                      {collaborator.name}
                    </Option>
                  ))}
              </Select>
            </>
          )}
          {
            user &&
              meet?.details?.updated_by === "demco" &&
              !isConfirmed &&
              !rescheduleIt && (
                // (!meet.details.user && meet.status === "new" && (
                <Button
                  // type="button"
                  disabled={variables === "cancel"}
                  className="mt-1 reschedule-btn-drawer confirm w-100"
                  onClick={() => mutateUpdateBooking("confirm")}
                >
                  {variables === "confirm" && updateLoading
                    ? "Confirming..."
                    : "Confirm Meeting"}
                </Button>
              )
            // ))
          }
          {!isConfirmed && !rescheduleIt && (
            // !(
            //   user.id === meet.details.client_id &&
            //   meet.details.status === "waiting"
            // ) &&
            <Button
              // type="button"
              disabled={!data}
              className={`reschedule-btn-drawer discard w-100 mt-3`}
              // onClick={() => mutateUpdateBooking("waiting")}
              onClick={() => {
                if (!rescheduleIt) {
                  setRescheduleIt(true);
                } else {
                  mutateUpdateBooking("waiting");
                }
              }}
            >
              {variables === "waiting" && updateLoading
                ? "Rescheduling..."
                : "Reschedule Meeting"}
            </Button>
          )}
          {!isConfirmed && !rescheduleIt && (
            <Button
              type="link"
              className="d-flex justify-content-center mx-auto mt-3"
              onClick={() => mutateUpdateBooking("cancel")}
            >
              {variables === "cancel" && updateLoading
                ? "Cancelling..."
                : "Cancel Meeting"}
            </Button>
          )}
          {isConfirmed && (
            <Button
              className="reschedule-btn-drawer confirm w-100"
              onClick={() => mutateUpdateBooking("cancel")}
            >
              {variables === "cancel" && updateLoading
                ? "Cancelling..."
                : "Cancel Meeting"}
            </Button>
          )}
          {rescheduleIt && (
            <div style={{ display: "flex", width: "100%" }}>
              <Button
                className="reschedule-btn-drawer discard"
                onClick={() => {
                  onCloseConfirmDrawerClient();
                  setIsConfirmed(false);
                  setRescheduleIt(false);
                }}
              >
                Discard
              </Button>
              <Button
                style={{
                  marginLeft: "1rem",
                }}
                className="reschedule-btn-drawer confirm"
                onClick={() => {
                  if (!rescheduleIt) {
                    setRescheduleIt(true);
                  } else {
                    mutateUpdateBooking("waiting");
                  }
                }}
                loading={updateLoading && variables === "waiting"}
              >
                {variables === "waiting" && updateLoading
                  ? "Rescheduling..."
                  : "Confirm"}
              </Button>
            </div>
          )}
        </div>
      )}
    </Drawer>
  );
}

export default ConfirmDrawerClient;
